module.exports = __webpack_public_path__ + "img/ic-facies.0f4709f6.svg";